import React from 'react'

function TestPage() {
  return (
    <div>
        <iframe width="560" height="815" src="https://app.heygen.com/embeds/ebcc6e136d744190b63d487e075ac987" title="Quiz Demo 4" frameborder="0" allow="encrypted-media; fullscreen;" allowfullscreen></iframe>
    </div>
  )
}

export default TestPage